import { render } from "./DeleteIcon.vue?vue&type=template&id=29aa42cc&scoped=true"
const script = {}

import "./DeleteIcon.vue?vue&type=style&index=0&id=29aa42cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29aa42cc"]])

export default __exports__